/**
 * StripeIntegrationPage
 *
 * Page for managing Stripe Connect integration.
 * Shows connection status and allows connecting/disconnecting Stripe account.
 *
 * @module stripe-connect/pages/StripeIntegrationPage
 */

import { useParams } from 'react-router-dom';
import { Box, Typography, Alert } from '@mui/material';
import { StripeIntegrationContent } from '../components/StripeIntegrationContent';
import { useGuideHighlight } from '@modules/guides/hooks/useGuideHighlight';

/**
 * StripeIntegrationPage Component
 *
 * Full page wrapper for Stripe Connect integration management.
 * Uses StripeIntegrationContent for the actual UI.
 */
export function StripeIntegrationPage() {
  const { projectId } = useParams<{ projectId: string }>();
  useGuideHighlight();

  if (!projectId) {
    return (
      <Box sx={{ p: 3 }}>
        <Alert severity="error">Project ID is required</Alert>
      </Box>
    );
  }

  return (
    <Box sx={{ p: 3, maxWidth: 800 }}>
      {/* Page Header */}
      <Typography variant="h5" sx={{ mb: 1, fontWeight: 600 }}>
        Stripe Integration
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        Connect your Stripe account to accept payments in your onboarding funnels.
      </Typography>

      {/* Content */}
      <StripeIntegrationContent projectId={projectId} />
    </Box>
  );
}

export default StripeIntegrationPage;
